import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/Services/navigation.service';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
//import { faCoffee } from '@awesome.me/kit-0629a5baa2/icons/classic/solid';
//import { faCoffee } from '@fortawesome/fontawesome-svg-core';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';
import * as moment from 'moment';
@Component({
  selector: 'app-topheader',
  templateUrl: './topheader.component.html',
  styleUrls: ['./topheader.component.css'],
})
export class TopheaderComponent implements OnInit {
imagepath = '';

userdata?: UserData;
employeeData?: EmployeeData;
pckgBeg: Date | undefined; 
pckgEnd: Date | undefined;

twofiftylogo: boolean | undefined; 

constructor(
  public navigation: NavigationService,
  private appConfigService: AppConfigService
) {
  this.imagepath = this.appConfigService.imagepath;
}

ngOnInit(): void {
  this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
  this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');

  if (
    (
      (moment(moment(this.userdata?.pckgBeg).format(moment.HTML5_FMT.DATE)
      ).isSameOrAfter(moment('2026-01-01T00:00:00'))) 

      && 

      (moment(moment(this.userdata?.pckgBeg).format(moment.HTML5_FMT.DATE)
      ).isSameOrBefore(moment('2026-12-31T23:59:59')))
    )

    &&

    (
      (moment(moment(this.userdata?.pckgEnd).format(moment.HTML5_FMT.DATE)
      ).isSameOrAfter(moment('2026-01-01T00:00:00'))) 

      &&

      (moment(moment(this.userdata?.pckgEnd).format(moment.HTML5_FMT.DATE)
      ).isSameOrBefore(moment('2026-12-31T23:59:59')))
    )

  ) 
  {
    this.twofiftylogo = true;
  }
  else {
    this.twofiftylogo = false; 
  }
}

      
}
